package com.patronat.top.core.auth

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.dto.UserRole
import com.russhwolf.settings.Settings
import com.russhwolf.settings.set
import kotlinx.coroutines.withContext

class AuthTokenStorage(
    private val settings: Settings,
    private val dispatchers: DispatcherProvider
) : TokenStorage {

    companion object {
        private const val KEY_ACCESS_TOKEN = "access_token"
        private const val KEY_REFRESH_TOKEN = "refresh_token"
        private const val KEY_USER_ROLE = "user_role"
    }

    override suspend fun getRole(): UserRole? = withContext(dispatchers.io) {
        val roleName = settings.getStringOrNull(KEY_USER_ROLE) ?: return@withContext null
        try {
            UserRole.valueOf(roleName)
        } catch (e: IllegalArgumentException) {
            null
        }
    }

    override suspend fun getAccessToken(): String? = withContext(dispatchers.io) {
        settings.getStringOrNull(KEY_ACCESS_TOKEN)
    }

    override suspend fun getRefreshToken(): String? = withContext(dispatchers.io) {
        settings.getStringOrNull(KEY_REFRESH_TOKEN)
    }

    override suspend fun saveTokens(accessToken: String, refreshToken: String, role: UserRole) = withContext(dispatchers.io) {
        settings[KEY_ACCESS_TOKEN] = accessToken
        settings[KEY_REFRESH_TOKEN] = refreshToken
        settings[KEY_USER_ROLE] = role.name
    }

    override suspend fun clear() = withContext(dispatchers.io) {
        settings.remove(KEY_ACCESS_TOKEN)
        settings.remove(KEY_REFRESH_TOKEN)
        settings.remove(KEY_USER_ROLE)
    }
}